module.exports = __webpack_public_path__ + "img/mastercard.a8f8b0ad.svg";